import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, Message, MessageService } from 'primeng/api';
import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import { ResultData, UIService } from 'src/app/core/services/ui.service';
import { DataService } from 'src/app/services/data.service';
import { environment } from 'src/environments/environment';
import { FAZILService, UserService } from '../core/services';
import { UsuarioModel } from '../modelo/usuario.model';
import { validateDni, validateRUC } from '../shared/helpers';
import { Md5 } from "md5-typescript";
import * as CryptoJS from 'crypto-js';
import { RegistroService } from '../registro/registro.service';

@Component({
    selector: 'app-app.resetpasswordconfig',
    templateUrl: './app.resetpasswordconfig.component.html'
})
export class AppResetpasswordConfigComponent implements OnInit {

    //Variables de configuración/mensajes
    appConfig = environment.settings;

    errors: Object = {};
    msgs: Message[] = [];

    //Variables con objeto de edición
    user: UsuarioModel = new UsuarioModel();
    userDB: UsuarioModel = new UsuarioModel();

    //Variables auxiliares
    password: string = '';
    passwordConfirm: string = '';
    passwordInvalid: boolean = false;

    cargandoDataInit: boolean = false;
    procesando: boolean = false;
    processFilter = false;
    verificando: boolean = false;
    verificandoData: ResultData;
    resultData: ResultData;
    resultDataButtons: any[] = [];
    mostrarResultData: boolean = false;
    ui: UIService;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private userService: UserService,
        private fazilService: FAZILService,
        private uiService: UIService,
        private dataService: DataService,
        private confirmationService: ConfirmationService,
        private breadcrumbService: BreadcrumbService,
        private messageService: MessageService,
        private registroService: RegistroService,
    ) {
        this.ui = uiService;
    }

    ngOnInit(): void {
        //Redireccionar si no existe un uuid
        this.user.uuid = this.registroService.getUserUUID();
        if (!this.user.uuid) {
            this.fazilService.irALogin();
        }
    }

    confirmarGuardarContrasenia() {
        this.ui.limpiarMessages();
        if (this.isPasswordInvalid()) {
            this.ui.mostrarMensaje("error", `${this.appConfig.validationMsgs.passwordInvalid}`);
        } else {
            this.confirmationService.confirm({
                message: `Ha añadido una nueva contraseña para su cuenta. <strong>¿Está seguro de actualizarla</strong>?.`,
                accept: () => {
                    this.guardarContrasenia();
                },
            });
        }
    }

    formPrincipalValid() {
        return this.user && this.user.uuid && this.password && this.password != '';
    }

    public guardarContrasenia(): void {
        this.ui.limpiarMessages();

        if (!this.formPrincipalValid()) {
            this.ui.mostrarMensaje("error", `${this.appConfig.ux.formIvalid}. Por favor vuelva a recargar la página..`);
        } else {
            this.verificandoData = this.ui.buildResultFromVerify(this.appConfig.ux.loadingMsg, this.appConfig.ux.messagesType.success);
            this.verificando = true;
            //Establecer valores UX
            //Encriptar contraseña
            //            var encrypted = CryptoJS.AES.encrypt(this.password, environment.credential_app);
            //            this.user.password = encrypted.toString();
            const passwordMd5 = Md5.init(this.password);
            this.user.password = passwordMd5;
            this.registroService.actualizarResetUsuarioContrasenia(this.user).subscribe(
                (data) => {
                    let msg = `¡Contraseña actualizada!. Enhorabuena ya podrás seguir facturando sin límites con ${this.appConfig.app.name}`
                    this.resultData = this.ui.buildResultFromData(msg, this.appConfig.ux.messagesType.success);
                    this.resultDataButtons = [];
                    this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonLogin);
                    this.procesando = false;
                    this.verificando = false;
                    this.mostrarResultData = true;
                },
                (err) => {
                    this.procesando = false;
                    this.verificando = false;
                    this.ui.mostrarError(err);
                }
            );
        }
    }

    /**
    ** Métodos de formulario
    **/
    ejecutarAccionResult(event, accion: string, item: any) {
        this.ui.limpiarMessages();
        if (accion == this.appConfig.ux.actionsExecute.close) {
            this.mostrarResultData = false;
        } else {
            this.ui.ejecutarAccionResultFromData(event, accion);//Acciones generales
        }
    }

    isPasswordInvalid() {
        this.ui.limpiarMessages();
        let passwordInvalid = true;
        if (this.password && this.passwordConfirm
            && (this.password.trim().includes(this.passwordConfirm.trim())
                && this.passwordConfirm.trim().includes(this.password.trim()))) {
            passwordInvalid = false;
        }
        return passwordInvalid;
    }

    comparePassword(event) {
        this.passwordInvalid = false;
        if ((this.password || this.passwordConfirm) && this.passwordConfirm != this.password) {
            this.passwordInvalid = true;
        }
    }

}